import { styled } from '@mui/system'
import {
  Box,
  Collapse,
  IconButton,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { MuiButton } from '../../../../components'
import { MEDIA, LEGEND_TEXT_COLOR_MAP } from '../../../../constants'

export const Wrapper = styled(Grid)(`
`)

const setTableColumnWidthFunc = () => {
    const headingTitleWidth = 200
    const actionWidth = 75
    const percentVal1 = (headingTitleWidth + actionWidth) / 2
    const percentVal2 = (headingTitleWidth + actionWidth + 170) / 2
    const barPercent = (headingTitleWidth + actionWidth) / 5
    
    return `
        & table {
            table-layout: fixed;
            & .headingTitle {width: ${headingTitleWidth}px; min-width: ${headingTitleWidth}px;}
            & .headingActions {width: ${actionWidth}px; min-width: ${actionWidth}px;}
        }
        &.totalColumn5 table {
            & .headingSentiment {width: 170px;}
            & .headingAttributes,
            & .headingSubBrands {width: calc(50% - ${percentVal2}px);}
        }
        &.totalColumn4 table {
            & .headingSentiment,
            & .headingAttributes {width: calc(50% - ${percentVal1}px);}
        }
        &.totalColumn3 table {
            & .headingSentiment {width: 100%;}
        }

        &.table table .positivePercent, &.table table .neutralPercent, &.table table .mixedPercent, &.table table .negativePercent, &.table table .totalPercent {width:calc(${20}% - ${percentVal1}px);}

        &.table table.activeTab1 .neutralPercent, &.table table.activeTab1 .mixedPercent, &.table table.activeTab1 .negativePercent, &.table table.activeTab1 .totalPercent {display:none;}
        &.table table.activeTab1 .positivePercent {width: 100%;}

        &.table table.activeTab2 .positivePercent, &.table table.activeTab2 .neutralPercent, &.table table.activeTab2 .mixedPercent, &.table table.activeTab2 .totalPercent {display:none;}
        &.table table.activeTab2 .negativePercent {width: 100%;}

        &.table table.typeSearchDrivers .positivePercent, &.table table.typeSearchDrivers .neutralPercent, &.table table.typeSearchDrivers .mixedPercent, &.table table.typeSearchDrivers .negativePercent {display:none;}
        &.table table.typeSearchDrivers .totalPercent {width: 100%;}

        &.table table.typeSearchDriversProgression3Level .positivePercent, &.table table.typeSearchDriversProgression3Level .neutralPercent, &.table table.typeSearchDriversProgression3Level .mixedPercent, &.table table.typeSearchDriversProgression3Level .negativePercent {display:none;}
        &.table table.typeSearchDriversProgression3Level .totalPercent {width: 100%;}
        
        &.table .tableContainerWrapper.table {border:0; background:#fff; width: calc(100% + 16px); margin-left: -8px; margin-right: -8px; }
        &.table .tableContainerWrapper.table .theme2 td {padding: 8px; }

        &.table .tableContainerWrapper.table .level3OuterWrapper {background: #F2F8FF; border:0; }
        &.table .tableContainerWrapper.table .level3OuterWrapper table .DriversTr{background:transparent !important; }

        &.table .tableContainerWrapper.table .level3OuterWrapper table tr,
        &.table .tableContainerWrapper.table .level3OuterWrapper table tr td,
        &.table .tableContainerWrapper.table .level3OuterWrapper table tr .level4OuterWrapper {background:transparent !important; }
    `
}

export const TableContainerWrapper = styled(TableContainer)(`
    overflow:visible;
    & .theme2 thead {
        display:none;
    }
    & .theme2 tbody > .DriversTr:first-of-type {
        border-top: 0 !important;
    }
    & .theme2 tr { 
        box-shadow: none !important;
    }
    & .theme2 td { 
        border:0;
    }
    & .theme2 .driverName {
        font-size: 12px;
    }
    & .theme1 tr.details .moreActiveButtonL3 .selected {
        background: #F5F5F5 !important;
    }
    & .theme1 tr.details .searchActiveButtonL3 .selected {
        background: transparent !important;
    }
    & .theme1 tr.details .searchActiveButtonL3 .level3Wrap .selected {
        background: #F5F5F5 !important;
    }

    & .typeDriversAndRatingImpacts .headingSentiment { max-width: 200px !important; width: 200px !important; }
    & .typeDriversAndRatingImpacts .headingImpactStarRating { max-width: 300px !important; width: 300px !important; }
    & .typeDriversAndRatingImpacts .headingAttributes { width: auto; }
    
    & .typeTopRelativeBrandsAnalysis .MuiTableHead-root { display: none; }
    & .typeTopRelativeBrandsAnalysis .headingTitle { max-width: 200px; width: 200px; }
    & .typeTopRelativeBrandsAnalysis .headingAttributes { display: none; }
    & .typeTopRelativeBrandsAnalysis .headingActions { display: none; }

    &.graph {
        border: 1px transparent solid;
        border-radius: 4px;
        & tbody tr{
            border-top: 1px transparent solid;
        }
    }
    &.table {
        border: 1px #D2D5DA solid;
        border-radius: 4px;
        & tbody tr{
            border-top: 1px #D2D5DA solid;
        }
        & .typeDriversWithoutSentiments {
            table-layout: auto;
        }
    }

    ${setTableColumnWidthFunc()}
`)

export const TableHeadWrapper = styled(TableHead)(`
    background: transparent;
    padding:20px 0;
    & img {
        padding:0 10px;
    }
`)

export const TableBodyWrapper = styled(TableBody)(`
    background:transparent;
    & .tr_heading{border-bottom: 1px #F1F1F3 solid; cursor: pointer !important;}
`)

export const TableRowWrapper = styled(TableRow)(`
    font-weight: 400; // 300;
    font-size: 14px;
    line-height: 14px;
    text-align: right;
    letter-spacing: -0.01em;
    color: #000000;

    & .hideP {
        display:none;
    }
    &.selected .headingTitle{
        color: #095BBD;
    }
    &.selected .searchSelected button.btnExpand {
        transform: rotate(180deg);
        & svg path{
            fill: #095BBD;
        }
    }
    &.selected .moreSelected button.btnMore svg path{
        fill: #095BBD;
    }
    &.details > td {
        background: #F6F6F5;
        padding:12px 8px;
        border-radius: 4px;
    }
    & td {
        padding:4px 8px;
        position:relative;
        font-weight: 400; // 300;
        line-height:18px;
        border: 0;
    }

    & .IsHighlighted {
        position:absolute;
        top:0; left:0;
        width:6px;
        height:100%;
        background: #D5732E;
    }

    & .Positive { color:${LEGEND_TEXT_COLOR_MAP.Positive}; }
    & .Neutral { color:${LEGEND_TEXT_COLOR_MAP.Natural}; }
    & .Negative { color:${LEGEND_TEXT_COLOR_MAP.Negative}; }
    & .Mixed { color:${LEGEND_TEXT_COLOR_MAP.Mixed}; }

    & .barWidth { min-width: 120px; width:13%; padding:4px 12px; }

`)

export const ContOuterWrap = styled(Box)(`
    display:flex;
    align-items: center;

    border: 1px #E7E7E6 solid;
    padding: 4px;
    background:#fff;
`)

export const BarWrap = styled(Box)(`
    width: 100%;
`)

export const ProgressBarWrapper = styled(Box)(`
    width: 100%;
    display: flex;
    align-items: center;
    & span { border-radius: 4px; }
`)

export const ContWrap = styled(Box)(`
    width:150px;
    text-align:right;
    line-height:16px;
    padding-right:10px;
`)

export const TableRowContent = styled(TableRow)(`
    background:#F5F5F5;
    & .tableCell{padding-bottom: 0, padding-top: 0}
    & .tr_collapse{padding-top: 15px; padding-bottom: 5px;}
`)

export const TableCellHead = styled(TableCell)(`
    text-transform: none !important;
    font-weight:600 !important;
    font-size:14px !important;
    line-height:21px !important;
    padding:8px;
    letter-spacing:0 !important;
`)

export const CollapseContent = styled(Box)(
  (props) => `
    margin-bottom:10px;
    display:flex;
    align-items:center;
    color: ${props.type.toLowerCase() === 'completed' ? '#000' : '#7E7E7E'};
`
)

export const TableChipCompleted = styled(MuiButton)(
  (props) => `
    padding:6px 0;
    margin-right: 5px;
    width:85px;
    text-align:center;
    
    font-weight: 400;
    font-size: 10px;
    line-height: 15px;

    color: #008767;
    background-color: #A0E1D2;
`
)

export const TableChipInProgress = styled(Box)(
  (props) => `
    padding:6px 0;
    margin-right: 5px;
    width:85px;
    text-align:center;
    
    font-weight: 400;
    font-size: 10px;
    line-height: 15px;

    color: #C88F16;
    background-color: #FFE3C3;
`)

export const PieWrapper = styled(Box)(
  (props) => `
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 10px;

    &:before, &:after {
        font-weight: 400;
        font-size: 15px;
    }
    &:before { color: ${LEGEND_TEXT_COLOR_MAP.Positive}; content: '${props.positive}%'; }
    &:after { color: ${LEGEND_TEXT_COLOR_MAP.Negative}; content: '${props.negative}%'; font-weight: 500; }
`)
